import axios from 'axios';
import { AuthModel, ChangePassword, UserModel } from './_models';
import { getTenantFromHost } from '../../../core/utils/tenant';

const API_URL = process.env.REACT_APP_MANUFACTURING_API_URL;
export const LOGIN_URL = `${API_URL}/staff/login`;
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/staff/profile`;
export const REQUEST_PASSWORD_URL = `${API_URL}/staff/forgot-password`;
export const REFRESH_TOKEN_URL = `${API_URL}/staff/refresh-token`;
export const GET_PERMISSIONS = `${API_URL}/staff/permissions`;
export const CHANGE_PASSWORD = `${API_URL}/staff/change-password`;

// Server should return AuthModel
export function login(userName: string, password: string) {
  const headers = {
    tenant: getTenantFromHost(),
  };
  return axios.post<AuthModel>(
    LOGIN_URL,
    {
      userName,
      password,
    },
    { headers: headers }
  );
}
export async function changePassword(
  password: string,
  newPassword: string,
  confirmNewPassword: string
) {
  return await axios.put<ChangePassword>(CHANGE_PASSWORD, {
    password,
    newPassword,
    confirmNewPassword,
  });
}
// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  const headers = {
    tenant: getTenantFromHost(),
  };
  return axios.post<{ result: boolean }>(
    REQUEST_PASSWORD_URL,
    {
      email,
    },
    { headers: headers }
  );
}

export function getUserByToken(token: string) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    headers: headers,
  });
}

export function getPermissions(token: string) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return axios.get<string[]>(GET_PERMISSIONS, {
    headers: headers,
  });
}

export function refreshtoken(token: string, refreshToken: string) {
  const headers = {
    tenant: getTenantFromHost(),
  };
  return axios.post<AuthModel>(
    REFRESH_TOKEN_URL,
    {
      token,
      refreshToken,
    },
    {
      headers: headers,
    }
  );
}
